export const EDIT_TEXT_PANEL = 'compPanels.panels.WRichText.settingsPanel';
export const AI_TEXT_CREATOR_PANEL =
  'compPanels.dynamicPanels.aiTextGeneratorPanel';
